export var USER_CLICK_TRACK_ID;
(function (USER_CLICK_TRACK_ID) {
    USER_CLICK_TRACK_ID["DATA_PANEL_OBJECT_CREATE_BUTTON"] = "data-panel-object-create-button";
    USER_CLICK_TRACK_ID["FORMULA_CREATE"] = "formula-create";
    USER_CLICK_TRACK_ID["FORMULA_EDITOR_SETTINGS_BUTTON"] = "formula-editor-settings-button";
    USER_CLICK_TRACK_ID["FORMULA_EDITOR_HELP_BUTTON"] = "formula-editor-help-button";
    USER_CLICK_TRACK_ID["SAVE_ANSWER_MENU_ITEM"] = "answer_save-answer-menu-item";
    USER_CLICK_TRACK_ID["CREATE_VIEW_MENU_ITEM"] = "answer_create-view-menu-item";
    USER_CLICK_TRACK_ID["SAVE_AS_COHORT_MENU_ITEM"] = "answer_save-as-cohort-menu-item";
    USER_CLICK_TRACK_ID["COPY_LINK_SHARE_OBJECT"] = "generic_copy-link-share-object";
    USER_CLICK_TRACK_ID["REQUEST_ACCESS_MENU_ITEM"] = "generic_click-request-access-menu-item";
    USER_CLICK_TRACK_ID["ADD_COLUMNS_SHOW_UNDERLYING_DATA"] = "answer_click-add-columns-show-underlying-data";
    USER_CLICK_TRACK_ID["QUERY_INFO_ICON"] = "answer_query-info-icon";
    USER_CLICK_TRACK_ID["QUERY_VISUALIZER"] = "answer_query-visualizer";
    USER_CLICK_TRACK_ID["QUERY_SQL"] = "answer_query-sql";
    USER_CLICK_TRACK_ID["ELLIPSIS_ICON"] = "generic_ellipsis-icon";
    USER_CLICK_TRACK_ID["COPY_AND_EDIT"] = "generic_copy-and-edit";
    USER_CLICK_TRACK_ID["PRESENTATION_UP"] = "presentation-up";
    USER_CLICK_TRACK_ID["PRESENTATION_DOWN"] = "presentation-down";
    USER_CLICK_TRACK_ID["PRESENTATION_CLOSE"] = "presentation-close";
    USER_CLICK_TRACK_ID["PRESENTATION_OPEN_VIZ_SLIDES_DROPDOWN"] = "presentation-open-viz-slides-dropdown";
    USER_CLICK_TRACK_ID["PRESENTATION_SELECT_VIZ"] = "presentation-select-viz";
    USER_CLICK_TRACK_ID["PINBOARD_ADD_FILTER"] = "pinboard-add-filter";
    USER_CLICK_TRACK_ID["CREATE_TAB"] = "create-tab";
    USER_CLICK_TRACK_ID["ADD_NOTE"] = "add-note";
    USER_CLICK_TRACK_ID["ADD_ANSWER"] = "add-answer-clicked";
    USER_CLICK_TRACK_ID["ADD_TAB"] = "add-tab";
    USER_CLICK_TRACK_ID["RENAME_TAB"] = "rename-tab";
    USER_CLICK_TRACK_ID["REMOVE_TAB"] = "remove-tab";
    USER_CLICK_TRACK_ID["DELETE_TAB"] = "delete-tab";
    USER_CLICK_TRACK_ID["OPEN_GRADIENT_MODAL"] = "open-gradient-modal";
    USER_CLICK_TRACK_ID["SHOW_ALL_CHIPS"] = "show-all-chips";
    USER_CLICK_TRACK_ID["SHOW_RELEVANT_CHIPS"] = "show-relevant-chips";
    USER_CLICK_TRACK_ID["TRY_NEW_EDITOR"] = "try-new-editor";
    USER_CLICK_TRACK_ID["ENABLE_LAYOUT_CHANGES_IN_SAME_LIVEBOARD"] = "enable-layout-changes-in-same-liveboard";
    USER_CLICK_TRACK_ID["ENABLE_LAYOUT_CHANGES_IN_COPIED_LIVEBOARD"] = "enable-layout-changes-in-copied-liveboard";
    USER_CLICK_TRACK_ID["CANCEL_CONFIGURE_ANNOUNCEMENT"] = "cancel-configure-announcement";
    USER_CLICK_TRACK_ID["DELETE_CONFIGURE_ANNOUNCEMENT"] = "delete-configure-announcement";
})(USER_CLICK_TRACK_ID || (USER_CLICK_TRACK_ID = {}));
//# sourceMappingURL=user-click-track-ids.js.map